<template>
  <svg
    viewBox="0 0 24 24"
    data-icon="stop-square"
    width="1em"
    height="1em"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="6"
      y="6"
      width="12"
      height="12"
      rx="2"
    />
  </svg>
</template>

<script>
export default { name: 'StopSquare' };
</script>

<style scoped lang="scss" type="text/scss"></style>
